import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';
import { UserSummaryComponent } from './user-summary/user-summary.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import { MessageBarComponent } from './message-bar/message-bar.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        UserSummaryComponent,
        RouterLink,
        NgIf,
        RouterOutlet,
        MatDivider,
        MessageBarComponent,
    ],
})
export class AppComponent implements OnDestroy {
  title = 'Intercessioner';

  private readonly userDisposable?: Subscription;

  isLoggedIn = false;

  constructor(public readonly authService: AuthService) {
    this.userDisposable = this.authService.authUser$?.subscribe((user) => {
      this.isLoggedIn = !!user;
    });
  }

  ngOnDestroy(): void {
    if (this.userDisposable) {
      this.userDisposable.unsubscribe();
    }
  }
}
